export default __webpack_public_path__ + "static/media/Group 3403.159f0283.png";